var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadBoardWidget',{key:`${_vm.orgRef}-lead-board`,attrs:{"orgRef":_vm.orgRef,"boardRef":_vm.boardRef,"nest-modals":"","auto-load":"","read-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }